const styles = {
  borderHead: {
    "font": {
      "bold": true,
      "size": 9,
      "color": {
        "indexed": 8
      },
      "name": "맑은 고딕",
      "family": 3,
      "charset": 129
    },
    "border": {
      "left": {
        "style": "thin",
        "color": {
          "indexed": 8
        }
      },
      "right": {
        "style": "thin",
        "color": {
          "indexed": 8
        }
      },
      "top": {
        "style": "thin",
        "color": {
          "indexed": 8
        }
      },
      "bottom": {
        "style": "thin",
        "color": {
          "indexed": 8
        }
      }
    },
    "fill": {
      "type": "pattern",
      "pattern": "none"
    },
    "alignment": {
      "horizontal": "center",
      "vertical": "middle",
      "wrapText": true
    }
  }
}

function getStyle(styleName) {
  if (styleName === 'border') {
    const style = JSON.parse(JSON.stringify(styles['borderHead']))
    style.font.bold = false
    return style
  }
  else if (styleName === 'borderLeft') {
    const style = JSON.parse(JSON.stringify(styles['borderHead']))
    style.font.bold = false
    style.alignment.horizontal = 'left'
    return style
  }
  else if (styleName === 'bg-borderHead') {
    const style = JSON.parse(JSON.stringify(styles['borderHead']))
    style.fill = {
      "type": "pattern",
      "pattern": "solid",
      "fgColor": {
        "theme": 2
      },
      "bgColor": {
        "indexed": 64
      }
    }
    return style
  }
  return JSON.parse(JSON.stringify(styles[styleName]))
}

function getCellStartIndex(cell) {
  const merge = cell.merge.split(':')
  const start = `${merge[0]}`.toUpperCase()
  let index = 0
  for (let i = 0; i < start.length; i++) {
    if (start.charCodeAt(i) >= 65) {
      index = index * 26 + start.charCodeAt(i) - 64
    }
  }
  return index
}

export default {
  addEmpty(worksheet, count) {
    worksheet.addRow([])
  },

  /**
   * 헤더를 추가함.
   * @param worksheet
   * @param cellInfos
   * [
   *   ...,
   *   {value: '테스트', style: 'border', merge: 'A:B'},
   * ]
   */
  addHeader(worksheet, cellInfos) {
    const rowHeight = 22.4
    const cellForm = [];

    // value 를 cellForm 에 넣어줌.
    for (const info of cellInfos) {
      cellForm[getCellStartIndex(info)] = info.value;
    }

    const row = worksheet.addRow(cellForm, 'i')
    row.height = rowHeight

    // mergeCells 를 만들어줌.
    for (const info of cellInfos) {
      const merge = info.merge.split(':')
      const start = `${merge[0]}`.toUpperCase()
      const end = `${merge[1]}`.toUpperCase()

      const cell = worksheet.getCell(`${start}${row._number}`)
      cell.style = getStyle(info.style || 'borderHead')
      worksheet.mergeCells(`${start}${row._number}:${end}${row._number}`)
    }
  },

  /**
   * table 을 추가함.
   * @param worksheet
   * @param tableInfo
   * {
   *    rowHeight,
   *    data: [
   *      ...,
   *      [
   *        {value: '테스트', style: 'border', colspan: 2},
   *        '테스트',
   *      ]
   *    ],
   * }
   *
   * style: borderHeader, borderLeft, borderRight, border ... styles 과 getStyle 에서 정의된 스타일을 사용할 수 있음.
   * rowspan 사용시, 다음 row 에서는 해당 cell 을 undefined 로 넣어주어야 함.
   * data: [
   *   [{ value: '테스트 1', rowspan: 2}, { value: '테스트 2', style: borderHeader }]
   *   [ undefined, '테스트 2' ]
   * ]
   */
  addTable(worksheet, tableInfo) {
    const rowHeight = tableInfo.rowHeight;
    // table 시작 row
    let startRow = 0;

    // 작업할 row 를 만들어줌.
    for (let i=0; i<tableInfo.data.length; i++) {
      const row = worksheet.addRow([], 'i')
      row.height = rowHeight
      if (i === 0) startRow = row._number;
    }

    // 데이터를 넣어줌.
    for (const row of tableInfo.data) {
      let colCount = 0;
      for (let colIndex=0; colIndex<row.length; colIndex++) {
        try {
          const col = row[colIndex];
          if (col === undefined) {
            colCount++;
            continue;
          }

          const colspan = col.colspan || 1;
          const rowspan = col.rowspan || 1;

          const startColumn = tableInfo.colgroup[colCount].split(':');
          const endColumn = tableInfo.colgroup[colCount + colspan - 1].split(':');
          const start = startColumn[0].toUpperCase();
          const end = endColumn[1].toUpperCase();
          const cell = worksheet.getCell(`${start}${startRow}`)

          // 별도의 옵션을 추가하지 않고 텍스트만 있을 경우, 기본설정으로 넣어줌.
          // 기본 style 은 border 로 설정함.
          cell.value = (typeof col === 'string') ? col : col.value
          cell.style = getStyle(col.style || 'border')

          worksheet.mergeCells(`${start}${startRow}:${end}${startRow + rowspan - 1}`)
          colCount += colspan;
        } catch (err) {
          if (colCount >= tableInfo.colgroup.length) {
            console.log("colgroup 의 길이가 데이터보다 짧습니다. 데이터 또는 colspan 을 확인해주세요.")
            console.log(row)
          }
        }
      }
      startRow++;
    }

  }
}
